<template>
	<v-card>
		<v-card-title >
			Comments
		</v-card-title>
		<div v-if="appointment">
			<v-card-text>
				<v-list v-for="(c, index) in appointment[key]" :key="index">
					<v-list-item-content>
						<v-list-item-title v-text="c.content"></v-list-item-title>
						<span class="overline">	{{ c.created.toDate() | moment("HH:mm D/MM/YYYY") }}</span>
					</v-list-item-content>					
				</v-list>
				<v-textarea label="Comment" v-model="comment"></v-textarea>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="red" text @click="$emit('close')">Close</v-btn>
				<v-btn color="primary" text	@click="sendComments">
					Send
				</v-btn>
			</v-card-actions>
		</div>
	</v-card>
</template>


<script>
	import Vuex from "vuex";
	import firebase from "firebase";
	export default{
		name: "AppointmentComments", 
		props: {
			"appointment": {type: Object}, 
		},
		computed: {
			...Vuex.mapState( {
				user: state => state.auth.user,
				view: state => state.auth.view,
			}),
			key(){
				return this.view + "Comments"
			}
		},
		data: () => {
			return {
				comment: ""
			}
		},
		methods:{
			sendComments: function(){
				var self = this;
				var data = {};
				data[this.key] = this.appointment[this.key];
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				var comment = {
					created: now, 
					author: this.user.uid, 
					content: this.comment
				}
				data[this.key].push( comment );
				self.$store.dispatch("updateDoc", {
					doc: "appointments/" + this.appointment.id,
					data: data, 
					action: "update"
				})
				self.comment = "";				
			}
		},
		created(){
			if( !this.appointment[this.key] ){
				this.appointment[this.key] = []
			}
		}
	}
</script>